import apiClient from "../apiClient";

const resource = "organization";

export default {
    // Anonymous: the login page reads it before sign-in.
    get: () => apiClient.get(resource),
    update: payload => apiClient.put(resource, payload),
    uploadLogo: formData => apiClient.post(`${resource}/logo`, formData),
    deleteLogo: () => apiClient.delete(`${resource}/logo`),
};
